import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';
import ProtectedRoute from './components/ProtectedRoute';

import Answers from './pages/examAnswers/examAnswers';
import Dashboard from './pages/ Dashboard';
import Login from './pages/Login';
import Profile from './pages/profile/Profile';
import UsefulVideos from './pages/usefulVideo/usefulVideo';
import ChangePassword from './pages/changePassword/changePassword';
import Exam from './pages/exam/ExamMasterTable';
import ExamPapersTable from './pages/exam/ExamPapers';
import AddQuestions from './pages/exam/addQuestion';
import Assignments from './pages/assignments/assignment';
import AnswerDetails from './pages/answers/answerDetails';

// Auth function
const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  console.log('Checking auth:', token ? '✅ Authenticated' : '❌ Not authenticated');
  return !!token;
};

// Custom loading component (optional)
const CustomLoading = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '4rem', height: '4rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      
    </div>
  </div>
);

function App() {
  console.log('=== APP RENDER ===');
  const token = localStorage.getItem('token');
  console.log('Token in localStorage:', token ? '✅ Present' : '❌ Missing');

  return (
    <Routes>
      {/* Public routes - Login page */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Protected routes - All other pages */}
      <Route element={
        <ProtectedRoute
          isAllowed={isAuthenticated}
          redirectRoute="/login"
          LoadingComponent={CustomLoading}
        />
      }>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path=":slug" element={<UsefulVideos />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="exam" element={<Exam />} />
          <Route path="exam-paper" element={<ExamPapersTable />} />
          <Route path="add-questions/:examId" element={<AddQuestions />} />
          <Route path="assignments" element={<Assignments />} />
          <Route path="answers/:id" element={<Answers />} />
          <Route path="answer-details/:id" element={<AnswerDetails />} />
        </Route>
      </Route>

      {/* Catch all - redirect to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
